<template>
  <v-toolbar
      color="blue darken-3"
      dark
      app
      :clipped-left="$vuetify.breakpoint.mdAndUp"
      fixed
  >
    <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
      <v-toolbar-side-icon @click.native.stop="$store.dispatch('toggleMainMenuDrawer')"></v-toolbar-side-icon>
      <span class="hidden-sm-and-down">Dashboard</span>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn icon to="/logout">
      <v-icon>exit_to_app</v-icon>
    </v-btn>
    <v-btn icon large round>
      <v-avatar @click="$router.push({ name: 'Profile' })" size="32px" tile>
          <!-- src="https://vuetifyjs.com/static/doc-images/logo.svg" -->
        <img
          :src="avatar"
        >
      </v-avatar>
    </v-btn>
  </v-toolbar>
</template>

<script>
  export default {
    name: 'AppToolbar',
    computed: {
      avatar () {
        return this.$store.getters.currentUser.avatar || this.$dfsConfig.default_avatar_url
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AppToolbar.vue?7d82af2f